<ng-container *ngIf="dataLoading && items.length == 0">
    <div class="content-centered-column">
        <div class="content-centered-row">
            <ion-spinner></ion-spinner>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="!dataLoading || items.length">
    <!-- <div class="header">
        <ion-row class="ion-no-padding">
            <ion-col size="12">
                <p class="title"></p>
            </ion-col>
        </ion-row>
    </div> -->
    <ng-container *ngFor="let item of items; let c = index">

        <stream-detail *ngIf="item.id != editId"
                         [stream]="item"
                         [event]="event"></stream-detail>

    </ng-container>

    <ion-infinite-scroll *ngIf="!detail"
                         threshold="100px"
                         (ionInfinite)="loadData($event)">
        <ion-infinite-scroll-content loadingSpinner="bubbles"
                                     [loadingText]="'STREAM_LIST_LOADING_MORE' | trns">
        </ion-infinite-scroll-content>
    </ion-infinite-scroll>
</ng-container>
